// Helper class of commonly used functions

import {
  Business,
  Contact,
  Patient,
  Practitioner,
  format,
  replacePlainText,
  setApplication,
  unword,
  word
} from './lib/localisable-controls';

import React from 'react';

interface IProps {
  children: string;
}

class Label extends React.Component<IProps> {
  render() {
    return <label>{z.format(this.props.children)}</label>;
  }
}

const z = {
  format,
  word,
  unword,
  Label,
  Patient,
  Practitioner,
  Business,
  Contact,
  setApplication,
  replacePlainText
};

export default z;
export {
  format,
  word,
  unword,
  Label,
  Patient,
  Practitioner,
  Business,
  Contact,
  setApplication,
  replacePlainText
};
